<script>
import { defaultSelectedKeys } from "@/config/exportSchemas";

const STORAGE_PREFIX = "export_columns_";

export default {
  name: "ExportColumnPicker",
  props: {
    typeKey: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.persist(val);
      },
    },
    allKeys() {
      return this.columns.map((c) => c.key);
    },
    checkAll: {
      get() {
        return this.columns.length > 0 && this.selected.length === this.columns.length;
      },
      set(val) {
        this.selected = val ? this.allKeys.slice() : [];
      },
    },
    isIndeterminate() {
      return this.selected.length > 0 && this.selected.length < this.columns.length;
    },
  },
  watch: {
    typeKey: {
      immediate: true,
      handler() {
        this.restoreOrDefault();
      },
    },
    columns() {
      this.restoreOrDefault();
    },
  },
  methods: {
    storageKey() {
      return STORAGE_PREFIX + this.typeKey;
    },
    persist(keys) {
      try {
        localStorage.setItem(this.storageKey(), JSON.stringify(keys));
      } catch (e) {
        /* ignore */
      }
    },
    restoreOrDefault() {
      const valid = new Set(this.allKeys);
      let next = [];
      try {
        const raw = localStorage.getItem(this.storageKey());
        if (raw) {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            next = parsed.filter((k) => valid.has(k));
          }
        }
      } catch (e) {
        next = [];
      }
      if (!next.length) {
        next = defaultSelectedKeys(this.columns).filter((k) => valid.has(k));
      }
      this.$emit("input", next);
    },
  },
};
</script>

<template>
  <div class="export-column-picker">
    <div class="mb-2 d-flex align-items-center">
      <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate">
        {{ $t("export.columns.select_all") }}
      </el-checkbox>
      <span class="text-muted ml-3 small">
        {{ $t("export.columns.selected_count", { n: selected.length, total: columns.length }) }}
      </span>
    </div>
    <el-checkbox-group v-model="selected" class="export-column-group">
      <el-checkbox
        v-for="col in columns"
        :key="col.key"
        :label="col.key"
        class="export-column-item"
      >
        {{ $t(col.labelKey) }}
        <span v-if="col.sheet" class="text-muted small">
          ({{ $t("export.statistics.sheet_" + col.sheet) }})
        </span>
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<style scoped>
.export-column-group {
  display: flex;
  flex-wrap: wrap;
}
.export-column-item {
  width: 240px;
  margin-right: 0;
  margin-bottom: 8px;
}
</style>
